import { render } from "./BaseTable.vue?vue&type=template&id=bb36be34&scoped=true&ts=true"
import script from "./BaseTable.vue?vue&type=script&lang=ts"
export * from "./BaseTable.vue?vue&type=script&lang=ts"

import "./BaseTable.vue?vue&type=style&index=0&id=bb36be34&scoped=true&lang=scss"

import exportComponent from "/Users/bekircankaya/Documents/GitHub/kurban-vekalet-frontend-eski-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb36be34"]])

export default __exports__